import Vue, { PropType } from 'vue';

type Option = {
  label: string;
  value: number | string;
  disabled: boolean;
};

// enum用のel-selectをラッピングしたコンポーネント
export default Vue.extend({
  name: 'ElwEnumSelect',

  props: {
    enum: {
      type: Object as PropType<Record<string, number | string>>,
      required: true,
    },
    value: {
      type: [Number, String],
      default: null,
    },
    allowUndefined: {
      type: Boolean,
      default: false,
    },
    allowNull: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    disabledOptionValues: {
      type: Array as PropType<number[] | string[]>,
      default: () => [],
    },
    size: {
      type: String as PropType<'large' | 'small' | 'mini'>,
    },
  },

  computed: {
    options(): Option[] {
      // enumはkeyとvalueの2重にループするため、filterで絞る
      return Object.keys(this.enum)
        .filter((x) => Number.isNaN(parseInt(x)))
        .map((k) => {
          const value = this.enum[k];
          return {
            label: typeof value === 'string' ? (value as string) : k,
            value: value,
            disabled: this.disabledOptionValues.includes(value as never),
          };
        });
    },
    selected: {
      get(): number | string | null {
        return this.value;
      },
      set(v: number | string | null): void {
        this.$emit('update:value', v);
      },
    },
  },
});
